<div class="iframe-container">
  <iframe width = "100%" height="100%" [src] = "iframeUrl" allow="clipboard-read; clipboard-write"></iframe>
</div>
